export default "__VITE_ASSET__CiXl8eb___"